{
  "formGeneralDescription": "This form allows you to configure your PKI connector, currently only Microsoft PKI are supported by LX CONNECT.",
  "formRootCaDescription": "The RootCA must be in .PEM format and must be less than 1MB in size.",
  "validation": {
    "url": "The URL of the PKI server is mandatory",
    "urlFormat": "Invalid URL format",
    "login": "The PKI Server Access ID is mandatory",
    "password": "The password of the PKI server is mandatory",
    "templateName": "Name is mandatory",
    "templateFormat": "Template name invalid",
    "pemFileSize": "The .PEM must be less than 1MB in size",
    "pemFileMandatory": "File must be a .PEM",
    "rootCa": "RootCA is mandatory",
    "pemFileEmpty": "The .PEM must not be empty",
    "pemFileInvalid": "The .PEM file is not valid"
  },
  "testConnection": {
    "messageSuccess": "The PKI server configuration is valid",
    "messageFailTitle": "Test connection failed",
    "messageFailConnectivity": "Invalid URL",
    "messageFailAuthentication": "Invalid couple login/password",
    "messageFailRootca": "Invalid RootCA",
    "tooltip": "Test the connection",
    "ok": "OK",
    "ko": "KO"
  },
  "button": {
    "viewCertificate": "View certificates"
  },
  "filters": {
    "searchByAlias": "Search by alias"
  },
  "noPki": "No PKI found",
  "alias": "Alias",
  "type": {
    "label": "Type",
    "EST": "EST",
    "MICROSOFT": "Microsoft"
  },
  "url": "URL",
  "delete": {
    "title": "Delete the PKI connection",
    "message": "Do you confirm the deletion of this PKI connection? No operation will be possible anymore with this PKI."
  },
  "form": {
    "title": {
      "create": "Create a new connection",
      "update": "Connection edition"
    },
    "warning": {
      "title": "PKI Certificate required",
      "message": "A dedicated PKI certificate with appropriate PKI tags must be present in the keystore"
    },
    "connectionSettings": {
      "title": "Connection settings"
    },
    "login": {
      "label": "Login"
    },
    "password": {
      "label": "Password"
    },
    "specificConfiguration": {
      "templateName": {
        "label": "Template name"
      },
      "retryAfter": {
        "label": "Retry interval time"
      },
      "label": {
        "urlLabel": "Label"
      }
    },
    "validate": {
      "create": "Add a connection",
      "update": "Save"
    },
    "cancel": {
      "confirm": {
        "title": {
          "create": "PKI connection creation",
          "update": "PKI connection update"
        },
        "message": {
          "create": "Do you wish to discard every input information and abandon the PKI connection creation? All information will be lost.",
          "update": "Do you wish to discard every input information and abandon the PKI connection update? All information will be lost."
        }
      }
    },
    "validation": {
      "alias": {
        "required": "Alias is required",
        "max": "Alias must be 50 characters max"
      },
      "url": {
        "required": "URL is required",
        "max": "URL must be 120 characters max"
      },
      "type": {
        "required": "Type is required"
      },
      "login": {
        "required": "Login is required"
      },
      "password": {
        "required": "Password is required"
      },
      "templateName": {
        "required": "Template name is required"
      },
      "intervalTime": {
        "required": "Retry interval time is required",
        "min": "The value cannot be less than 60"
      },
      "urlLabel": {
        "max": "Label must be 100 characters max",
        "format": "The label must contain only alphanumeric characters, hyphens, and underscores"
      }
    },
    "trustChainsAliases": {
      "label": "Associated certificate",
      "selectAll": "Select all certificates",
      "selectSearchPlaceholder": "Search by alias",
      "selectNoResult": "No certificates found",
      "help": "The PKI will be used as a proxy to renew the certificates of devices identified by the truststore certificate, while also handling the renewal of the keystore certificates."
    },
    "testConnection": {
      "button": "Test the connection",
      "noPassword": "Please input a password in order to test the connection"
    }
  }
}
